// Code review - In Progress
// Documentation - In Progress
import React, { useEffect, useState } from "react";
import { mainTable } from "../css/Common";
import InputText from "../ReusableComponents/InputText";
import DropDown from "../ReusableComponents/DropDown";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
import download from "../image/download.png";
import MultiSelect from "../ReusableComponents/MultiSelect";
import { BindAPI } from "../services/APIConnection";

const UserDetails = ({ data, data2, data3 }) => {


  const [stateDropDown, setStateDropDown] = useState([]);
  const [locationDropDown, setLocationDropDown] = useState([]);


  return (
    <div class="w-full">
      <div>
        <div className={mainTable.mainContentScreen}>
          <form class="overflow-auto p-5 lg:h-96 md:min-h-[60vh] md:max-h-[60vh] min-h-fit max-h-fit sm:min-h-fit  sm:max-h-fit ">
            <div className={mainTable.grid3}>
              <InputText
                inputType={"text"}
                title={"First Name"}
                name={"firstName"}
                content={data.FirstName}
                classStar={"text-red-500"}
                disabled={true}
              />

              <InputText
                inputType={"text"}
                title={"Middle Name"}
                name={"middleName"}
                content={data.MiddleName}
                disabled={true}
              />
              <InputText
                inputType={"text"}
                title={"Last Name"}
                name={"lastName"}
                content={data.LastName}
                classStar={"text-red-500"}
                disabled={true}
              />

              <InputText
                inputType={"email"}
                title={"Email"}
                name={"email"}
                placeholder={"abc@gmail.com"}
                content={data.UserEmail}
                classStar={"text-red-500"}
                disabled={true}
              />

              <InputText
                inputType={"text"}
                title={"Mobile Number"}
                name={"phone"}
                placeholder={"9347583939"}
                content={data.UserMobile}
                classStar={"text-red-500"}
                disabled={true}
              />
              <AutoDropDown
                title="Designation"
                options={[]}
                placeholder="Select"
                name="state"
                selectedOption={data2[0]}
                Class="custom-class"
                //disabled="false"
                // tabIndex="1"
                classStar={"text-red-500"}
                disabled={true}
              />
              <AutoDropDown
                title="Role/Groups"
                options={[]}
                placeholder="Select"
                name="state"
                selectedOption={data2[1]}
                Class="custom-class"
                //disabled="false"
                // tabIndex="1"
                classStar={"text-red-500"}
                disabled={true}
              />

              <DropDown
                classDiv="hidden"
                title="Country"
                options={[]}
                placeholder="Select"
                name="country"
                selectedOption={"country"}
              />
              <InputText
                inputType={"text"}
                title={"State"}
                name={"State"}
                content={data.State}
                classStar={"text-red-500"}
                disabled={true}
              />
              <InputText
                inputType={"text"}
                title={"City"}
                name={"City"}
                content={data.City}
                classStar={"text-red-500"}
                disabled={true}
              />




              <div className="flex">
                {data && data.UserProfileImg != null && data.UserProfileImg != "" && (
                  <div>
                    <img
                      src={data ? data?.UserProfileImg : download}
                      alt="Image"
                      className="rounded-full w-20 h-20"
                    />
                  </div>
                )}
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default UserDetails;
